import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import { formatCurrency, formatInteger } from './fnbEodReportUtils'

function SummaryItem({ label, value }) {
  return (
    <Col sm={6} lg={4}>
      <div className="fnb-eod-summary-item">
        <p className="fnb-eod-summary-item__label mb-1">{label}</p>
        <p className="fnb-eod-summary-item__value mb-0">{value}</p>
      </div>
    </Col>
  )
}

export default function FnbEodReportSummary({ summary }) {
  if (!summary) return null

  return (
    <Card body className="card--md">
      <h2 className="h5 mb-3">Summary</h2>
      <Row className="g-3">
        <SummaryItem
          label="Total Gross Sales"
          value={formatCurrency(summary.totalGrossSales)}
        />
        <SummaryItem
          label="Complimentary Items"
          value={formatInteger(summary.complimentaryItems)}
        />
        <SummaryItem
          label="Waste / Spoilage"
          value={formatInteger(summary.wasteSpoilage)}
        />
        <SummaryItem
          label="Total Units Sold"
          value={formatInteger(summary.totalUnitsSold)}
        />
        <SummaryItem
          label="Average Transaction Value"
          value={formatCurrency(summary.averageTransactionValue)}
        />
        <SummaryItem
          label="Transactions Processed"
          value={formatInteger(summary.transactionsProcessed)}
        />
      </Row>
    </Card>
  )
}
